// Configuration des tarifs BookMySalon Pro
export const PRICING_CONFIG = {
  // Abonnements mensuels
  monthly: [
    {
      id: 'solo',
      name: 'Solo Studio',
      subtitle: 'Artisans indépendants & micro-entreprises',
      price: 14.99,
      maxOperators: 1,
      features: [
        '1 Compte Opérateur Dédié',
        'Passerelle de prise d\'ordres web',
        '50 Crédits SMS d\'alerte / mois',
        'Rappels synchronisés multicanaux'
      ],
      buttonText: 'Démarrer le cycle',
      recommended: false
    },
    {
      id: 'equipe',
      name: 'Équipe Lab',
      subtitle: 'Structures comptant 2 à 3 collaborateurs',
      price: 29.99,
      minOperators: 2,
      maxOperators: 3,
      features: [
        'Jusqu\'à 3 postes d\'opérateurs',
        'Matrice algorithmique des expertises',
        'Automatisation IA & Happy Hours',
        'Index partagé anti-absentéisme'
      ],
      buttonText: 'Sélectionner l\'offre',
      recommended: true
    },
    {
      id: 'salon',
      name: 'Salon Plus Cloud',
      subtitle: 'Réseaux d\'établissements & équipes larges',
      price: 49.99,
      minOperators: 4,
      maxOperators: 8,
      features: [
        'De 4 à 8 comptes collaborateurs',
        'Plannings avancés multi-agendas',
        'Intégration totale des flux IA',
        'Équipe support technique prioritaire'
      ],
      buttonText: 'Souscrire au plan',
      recommended: false
    }
  ],

  // Offre Lifetime (À vie) - Système de paliers
  lifetime: {
    enabled: true,
    maxCount: 100, // Total de places disponibles
    tiers: [
      {
        tier: 1,
        from: 1,
        to: 30,
        price: 199,
        label: 'Early Bird',
        badge: '🔥 Places 1-30',
        color: '#10B981' // green
      },
      {
        tier: 2,
        from: 31,
        to: 60,
        price: 299,
        label: 'Pioneer',
        badge: '⚡ Places 31-60',
        color: '#F59E0B' // orange
      },
      {
        tier: 3,
        from: 61,
        to: 100,
        price: 499,
        label: 'Founder',
        badge: '🎯 Places 61-100',
        color: '#EF4444' // red
      }
    ],
    features: [
      '✅ Accès illimité à vie',
      '✅ Toutes les fonctionnalités Pro',
      '✅ Mises à jour gratuites',
      '✅ Support prioritaire',
      '✅ Badge "Membre Fondateur"',
      '✅ Aucun frais mensuel - Jamais'
    ]
  }
}

// Fonction pour calculer le palier lifetime actuel
export function getCurrentLifetimeTier(firmCount) {
  if (firmCount >= PRICING_CONFIG.lifetime.maxCount) {
    return null // Plus de places disponibles
  }

  const nextPosition = firmCount + 1
  const tier = PRICING_CONFIG.lifetime.tiers.find(
    t => nextPosition >= t.from && nextPosition <= t.to
  )

  if (!tier) return null

  return {
    ...tier,
    position: nextPosition,
    remaining: tier.to - firmCount,
    percentFull: Math.round((firmCount / PRICING_CONFIG.lifetime.maxCount) * 100)
  }
}

// Fonction pour obtenir le prix mensuel selon le type de compte
export function getMonthlyPrice(typeCompte, nombreEmployes = 1) {
  if (nombreEmployes === 1) {
    return PRICING_CONFIG.monthly.find(p => p.id === 'solo')
  } else if (nombreEmployes >= 2 && nombreEmployes <= 3) {
    return PRICING_CONFIG.monthly.find(p => p.id === 'equipe')
  } else if (nombreEmployes >= 4) {
    return PRICING_CONFIG.monthly.find(p => p.id === 'salon')
  }

  return PRICING_CONFIG.monthly[0] // Par défaut Solo
}
